export default __webpack_public_path__ + "static/bree-serif-v10-latin-regular-a2546ef53ba740e61e302f4dd6633701.woff";